
export function getBrowserInfo() {
  const userAgent = navigator.userAgent;
  let browserName = "Desconhecido";
  
  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "Chrome";
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "Firefox";
  } else if (userAgent.match(/safari/i)) {
    browserName = "Safari";
  } else if (userAgent.match(/opr\//i)) {
    browserName = "Opera";
  } else if (userAgent.match(/edg/i)) {
    browserName = "Edge";
  }
  
  return browserName;
}

export function getDeviceInfo() {
  const userAgent = navigator.userAgent;
  let deviceType = "Desktop";
  
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
    deviceType = "Mobile";
    
    if (/iPad|Tablet|Android(?!.*Mobile)/i.test(userAgent)) {
      deviceType = "Tablet";
    }
  }
  
  return deviceType;
}

export function getDeviceId() {
  // Generate or retrieve a unique device ID
  let deviceId = localStorage.getItem('device_id');
  
  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem('device_id', deviceId);
  }
  
  return deviceId;
}
